import {
  Baby,
  Briefcase,
  Car,
  Dumbbell,
  Flower2,
  Gem,
  Hammer,
  Home,
  Package,
  PawPrint,
  Shirt,
  Smartphone,
  Sofa,
  Tent,
  User,
  type LucideIcon,
} from "lucide-react";

export type Category = {
  slug: string;
  label: string;
  icon: LucideIcon;
};

export const CATEGORIES: Category[] = [
  { slug: "fordon", label: "Fordon", icon: Car },
  { slug: "bostad", label: "Bostad & tomt", icon: Home },
  { slug: "for-hemmet", label: "För hemmet", icon: Sofa },
  { slug: "elektronik", label: "Elektronik", icon: Smartphone },
  { slug: "personligt", label: "Personligt", icon: User },
  { slug: "fritid-hobby", label: "Fritid & hobby", icon: Tent },
  { slug: "affarsverksamhet", label: "Affärsverksamhet", icon: Briefcase },
  { slug: "hobby-samlarprylar", label: "Hobby & samlarprylar", icon: Gem },
  { slug: "verktyg-bygg", label: "Verktyg & bygg", icon: Hammer },
  { slug: "sport-traning", label: "Sport & träning", icon: Dumbbell },
  { slug: "barnartiklar", label: "Barnartiklar & leksaker", icon: Baby },
  { slug: "djur", label: "Djur & tillbehör", icon: PawPrint },
  { slug: "tradgard", label: "Trädgård & växter", icon: Flower2 },
  { slug: "mode-skonhet", label: "Mode & skönhet", icon: Shirt },
  { slug: "ovrigt", label: "Övrigt", icon: Package },
];

export const CATEGORY_SLUGS = CATEGORIES.map((c) => c.slug);

export function categoryLabel(slug: string): string {
  return CATEGORIES.find((c) => c.slug === slug)?.label ?? "Övrigt";
}

export function categoryIcon(slug: string): LucideIcon {
  return CATEGORIES.find((c) => c.slug === slug)?.icon ?? Package;
}
